module.exports = __webpack_public_path__ + "img/head-eeg.40040d9d.svg";